/* BTTO price drop alerts -> Klaviyo (client API, public key only) */
(function () {
  'use strict';
  var REVISION = '2025-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function post(company, path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) return r;
      return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 200)); });
    });
  }

  function storeKey(id) { return 'btto_palert_' + id; }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var company = root.dataset.company, list = root.dataset.list, pid = root.dataset.productId;
    var dialog = document.getElementById(root.dataset.dialog);
    if (!dialog) return;
    var form = dialog.querySelector('[data-btto-palert-form]');
    var input = form.querySelector('input[type=email]');
    var err = dialog.querySelector('[data-btto-palert-error]');
    var submit = dialog.querySelector('[data-btto-palert-submit]');
    var label = root.querySelector('[data-btto-palert-label]');
    var item = {};
    try { item = JSON.parse(dialog.querySelector('[data-btto-palert-item]').textContent); } catch (e) {}

    try {
      var saved = localStorage.getItem(storeKey(pid));
      if (saved) { label.textContent = 'Price alert set'; root.classList.add('is-set'); }
    } catch (e) {}

    function show(step) {
      dialog.querySelectorAll('[data-btto-palert-step]').forEach(function (p) { p.hidden = p.dataset.bttoPalertStep !== step; });
    }
    function open() {
      show('form'); err.hidden = true;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      setTimeout(function () { input.focus(); }, 30);
    }
    function close() { if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); }

    root.querySelector('[data-btto-palert-open]').addEventListener('click', open);
    dialog.querySelectorAll('[data-btto-palert-close]').forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; input.focus(); return; }
      err.hidden = true; submit.disabled = true; submit.textContent = 'Setting alert...';

      var profile = { data: { type: 'profile', attributes: { email: email } } };
      var subscribe = post(company, 'subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Price drop alert',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: { 'Price Alert Last Product': item.ProductName || '' },
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      });
      // Record the view against this email so Klaviyo's Price Drop trigger picks them up.
      var viewed = post(company, 'events', {
        data: { type: 'event', attributes: {
          properties: item,
          value: item.PriceValue,
          metric: { data: { type: 'metric', attributes: { name: 'Viewed Product' } } },
          profile: profile
        } }
      });
      var requested = post(company, 'events', {
        data: { type: 'event', attributes: {
          properties: item,
          value: item.PriceValue,
          metric: { data: { type: 'metric', attributes: { name: 'Price Alert Requested' } } },
          profile: profile
        } }
      });

      Promise.all([subscribe, viewed, requested]).then(function () {
        try { localStorage.setItem(storeKey(pid), String(Date.now())); } catch (x) {}
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (x) {}
        dialog.querySelector('[data-btto-palert-email]').textContent = email;
        label.textContent = 'Price alert set'; root.classList.add('is-set');
        show('done');
      }).catch(function (x) {
        if (window.console) console.warn('Price alert failed', x);
        err.textContent = 'Sorry, something went wrong. Please try again.'; err.hidden = false;
      }).then(function () { submit.disabled = false; submit.textContent = 'Set price alert'; });
    });
  }

  function boot() { document.querySelectorAll('[data-btto-palert]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
